import React from 'react';
import AdminReleaseNotesListPage from '../../components/release-notes/AdminReleaseNotesListPage';
import AdminDashboardLayout from '../../layout/dashboard/AdminDashboardLayout';

const AdminReleaseNotesPage = () => {
  return (
    <AdminDashboardLayout>
      <AdminReleaseNotesListPage />
    </AdminDashboardLayout>
  );
};

export default AdminReleaseNotesPage;
